"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = function _default(palette, color) {
  if (color === 'divider') {
    return palette.divider;
  }

  if (color.includes('.') && !color.includes('rgb') && !color.includes('hsl')) {
    return (0, _lodash["default"])(palette, color);
  }

  return color;
};

exports["default"] = _default;